import React from "react";
import propTypes from "prop-types";
import { useFormContext } from "./Form";
import { getId } from "./field";

const Label = ({
    className,
    children,
    required = false,
    ...props
}) => {
    const context = useFormContext();
    const id = getId("fieldset-legend", context);

    return (
        <div className={`smart-legend ${className}`}>
            <context.LegendTag id={id} {...props}>
                { children }
            </context.LegendTag>
            {required && <span className="text-lx inline-required">
                <i className="far fa-asterisk" />
            </span>}
        </div>
    );
};

Label.propTypes = {
    className: propTypes.string,
    children: propTypes.any,
    required: propTypes.bool
};

export default Label;